import React, { MouseEvent } from 'react';

interface CountrySelectorFooterProps {
  footerLink: string;
  footerText: string;
  footerLinkHref: string;
  RedirectedIntro: string;
  RemoveSettingsText: string;
}

export const CountrySelectorFooter = ({
  footerLink,
  footerText,
  footerLinkHref,
  RedirectedIntro,
  RemoveSettingsText,
}: CountrySelectorFooterProps) => {
  const isCommertialSiteHomePage = () => {
    const site = window.location.href;
    if (
      site == 'https://www.alfalaval.com' ||
      site == 'https://www.alfalaval.com/' ||
      site == 'https://alfalaval.com' ||
      site == 'https://alfalaval.com/' ||
      site == 'https://www.alfalaval.com/?remove-preferred-site=true'
    ) {
      return true;
    }
    return false;
  };

  const isThisSiteIsPreferedSiteAndCommertialSite = () => {
    if (
      window.localStorage.getItem('preferred-site') == 'https://www.alfalaval.com/' &&
      isCommertialSiteHomePage()
    ) {
      return true;
    } else {
      return false;
    }
  };

  const removeSettings = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.localStorage.removeItem('preferred-site');
    document.location.href =
      (e.target as HTMLAnchorElement).href + '?remove-preferred-site=' + true;
  };

  const displayGeolocationForLocalSite = () => {
    if (window.localStorage.getItem('preferred-site') != null) {
      return true;
    }
    return false;
  };

  return (
    <div className='c-country-selector-block-footer'>
      {footerText} <a href={footerLinkHref}>{footerLink}</a>
      {displayGeolocationForLocalSite() && !isThisSiteIsPreferedSiteAndCommertialSite() && (
        <div>
          {RedirectedIntro && <p className='redirected-message'>{RedirectedIntro} </p>}
          {RemoveSettingsText && (
            <a
              href='https://www.alfalaval.com/'
              className='c-button is-primary is-small is-border'
              onClick={removeSettings}
            >
              {RemoveSettingsText}
            </a>
          )}
        </div>
      )}
    </div>
  );
};
